import Login from "./pages/public/Login";
import Home from "./pages/Home";
import Perfil from "./pages/Perfil";
import EditarEmail from "./pages/EditarEmail";
import EditarDadosProfissionais from "./pages/EditarDadosProfissionais";
import ValidarDataNascimento from "./pages/public/ValidarDataNascimento";
import TermoDeUso from "./pages/public/TermoDeUso";
import ResetSenhaCpf from "./pages/public/ResetSenhaCpf";
import ResetSenhaSMS from "./pages/public/ResetSenhaSMS";
import DefinirSenha from "./pages/DefinirSenha";
import ValidarSenha from "./pages/ValidarSenha";
import EditarEndereco from "./pages/EditarEndereco";
import Telefones from "./pages/Telefones";
import AdicionarCelular from "./pages/AdicionarCelular";
import VerificarCodigoSMS from "./pages/VerificarCodigoSMS";
import AdicionarRedeSocial from "./pages/AdicionarRedeSocial";
import InformarRedeSocial from "./pages/InformarRedeSocial";
import SemTelefoneVerificado from "./pages/SemTelefoneVerificado";
import RedesSociais from "./pages/RedesSociais";
import AlterarSenha from "./pages/AlterarSenha";
import DrawerContent from "./components/DrawerContent";
import Vagas from "./pages/Vagas";
import Vaga from "./pages/Vaga";

import { createStackNavigator } from "react-navigation-stack";

import { createDrawerNavigator } from "react-navigation-drawer";
import Cursos from "./pages/Cursos";

export const SignedOutRoutes = createStackNavigator({
  Login: {
    screen: Login,
    navigationOptions: {
      headerShown: false,
    },
  },
  TermoDeUso: {
    screen: TermoDeUso,
    navigationOptions: {
      headerShown: false,
    },
  },
  ValidarDataNascimento: {
    screen: ValidarDataNascimento,
    navigationOptions: {
      headerShown: false,
    },
  },
  DefinirSenha: {
    screen: DefinirSenha,
    navigationOptions: {
      headerShown: false,
    },
  },
  ValidarSenha: {
    screen: ValidarSenha,
    navigationOptions: {
      headerShown: false,
    },
  },
  SemTelefoneVerificado: {
    screen: SemTelefoneVerificado,
    navigationOptions: {
      title: "VAMOS MANTER CONTATO",
      gestureEnabled: false,
      headerShown: false,
    },
  },
  AdicionarCelular: {
    screen: AdicionarCelular,
    navigationOptions: {
      title: "NOVO TELEFONE",
    },
  },
  VerificarCodigoSMS: {
    screen: VerificarCodigoSMS,
    navigationOptions: {
      title: "VERIFICAR CÓDIGO",
    },
  },
  ResetSenhaCpf: {
    screen: ResetSenhaCpf,
    navigationOptions: {
      headerShown: false,
    },
  },
  ResetSenhaSMS: {
    screen: ResetSenhaSMS,
    navigationOptions: {
      headerShown: false,
    },
  },
});

const HomeNavigation = createStackNavigator({
  Home: {
    screen: Home,
  },
  SemTelefoneVerificado: {
    screen: SemTelefoneVerificado,
    navigationOptions: {
      title: "VAMOS MANTER CONTATO",
      gestureEnabled: false,
      headerShown: false,
    },
  },
  AdicionarCelular: {
    screen: AdicionarCelular,
    navigationOptions: {
      title: "NOVO TELEFONE",
    },
  },
  VerificarCodigoSMS: {
    screen: VerificarCodigoSMS,
    navigationOptions: {
      title: "VERIFICAR CÓDIGO",
    },
  },
  AdicionarRedeSocial: {
    screen: AdicionarRedeSocial,
    navigationOptions: {
      drawerLockMode: "locked-closed",
      gestureEnabled: false,
      headerShown: false,
    },
  },
  InformarRedeSocial: {
    screen: InformarRedeSocial,
    navigationOptions: {
      headerShown: false,
    },
  },
  Vaga: {
    screen: Vaga,
    navigationOptions: {
      title: "Detalhes da Vaga",
    },
  },
});

const RedesNavigation = createStackNavigator({
  RedesSociais: {
    screen: RedesSociais,
    navigationOptions: {
      title: "Redes Sociais",
    },
  },
  AdicionarRedeSocial: {
    screen: AdicionarRedeSocial,
    navigationOptions: {
      drawerLockMode: "locked-closed",
      gestureEnabled: false,
      headerShown: false,
    },
  },
  InformarRedeSocial: {
    screen: InformarRedeSocial,
    navigationOptions: {
      headerShown: false,
    },
  },
});

const PerfilNavigation = createStackNavigator({
  Perfil: {
    screen: Perfil,
    navigationOptions: {
      title: "PERFIL",
    },
  },
  EditarEndereco: {
    screen: EditarEndereco,
    navigationOptions: {
      title: "EDITAR ENDEREÇO",
    },
  },
  EditarDadosProfissionais: {
    screen: EditarDadosProfissionais,
    navigationOptions: {
      title: "INFORMAÇÕES PROFISSIONAIS",
    },
  },
  EditarEmail: {
    screen: EditarEmail,
    navigationOptions: {
      headerShown: false,
      title: "EDITAR EMAIL",
    },
  },
  AlterarSenha: {
    screen: AlterarSenha,
    navigationOptions: {
      title: "ALTERAR SENHA",
    },
  },
});

const DrawerNavigatorConfig = {
  minSwipeDistance: 20,
  gestureEnabled: true,
  hideStatusBar: false,
};

const TelefonesNavigation = createStackNavigator({
  Telefones: {
    screen: Telefones,
  },
  AdicionarCelular: {
    screen: AdicionarCelular,
    navigationOptions: {
      title: "NOVO TELEFONE",
    },
  },
  VerificarCodigoSMS: {
    screen: VerificarCodigoSMS,
    navigationOptions: {
      title: "VERIFICAR CÓDIGO",
    },
  },
});

const CursosNavigation = createStackNavigator({
  Cursos: {
    screen: Cursos,
    navigationOptions: {
      title: "Meus Cursos",
    },
  },
});

const VagasNavigation = createStackNavigator({
  Vagas: {
    screen: Vagas,
    navigationOptions: {
      title: "Minhas Vagas",
    },
  },
  Vaga: {
    screen: Vaga,
    navigationOptions: {
      title: "Detalhes da Vaga",
    },
  },
});

export const SignedInRoutes = createDrawerNavigator(
  {
    Home: HomeNavigation,
    Perfil: PerfilNavigation,
    Telefones: TelefonesNavigation,
    ["Redes Sociais"]: RedesNavigation,
    ["Meus Cursos"]: CursosNavigation,
    ["Minhas Vagas"]: VagasNavigation,
  },
  {
    contentComponent: DrawerContent,
    hideStatusBar: false,
    drawerBackgroundColor: "#000D",
    contentOptions: {
      labelStyle: {
        fontFamily: "Montserrat-Medium",
        fontWeight: "normal"
      },
      itemStyle: {
        borderRadius: 6,
        marginHorizontal: 8,
        borderBottomWidth: 1,
      },
      inactiveTintColor: "#C1C1C1",
      activeTintColor: "#F1F1F1",
      activeBackgroundColor: "#de1d13",
    },
  }
);

export const createRootNavigator = (signedIn = false) => {
  return createStackNavigator(
    {
      SignedIn: {
        screen: SignedInRoutes,
        navigationOptions: ({ navigation }) => ({
          gestureEnabled: false,
        }),
      },
      SignedOut: {
        screen: SignedOutRoutes,
      },
    },
    {
      headerMode: "none",
      mode: "modal",
      initialRouteName: signedIn ? "SignedIn" : "SignedOut",
      navigationOptions: {
        gesturesEnabled: false,
      },
    }
  );
};

// const MainNavigator = createStackNavigator({});

// const App = createAppContainer(MainNavigator);

// export default App;
